import { ResponsiveBar } from '@nivo/bar'
import { COLOR } from '../../data/Constants'
const BarGroupedChart = ({ data }) => (
    <ResponsiveBar
        data={data}
        keys={[
            'goal',
            'assist',

        ]}
        indexBy="league"
        margin={{ top: 50, right: 130, bottom: 50, left: 60 }}
        padding={0.5}
        valueScale={{ type: 'linear' }}
        indexScale={{ type: 'band', round: true }}
        colors={[COLOR.POWDERBLUE, COLOR.TIFFANYBLUE]}
        theme={{
                fontSize: '14px',
                textColor: COLOR.TIFFANYBLUE,
            }}
        borderColor={{
            from: 'color',
            modifiers: [
                [
                    'darker',
                    1.6
                ]
            ]
        }}
        axisTop={null}
        axisRight={null}
        axisBottom={{
            tickSize: 5,
            tickPadding: 5,
            tickRotation: 0,
            legend: 'league',
            legendPosition: 'middle',
            legendOffset: 32
        }}
        axisLeft={{
            tickSize: 5,
            tickPadding: -15,
            tickRotation: 0,
            legend: 'total (goal + assist)',
            legendPosition: 'middle',
            legendOffset: -40,
            legendRotation: 90
        }}
        labelSkipWidth={15}
        labelSkipHeight={0}
        labelTextColor= {COLOR.EERIEBLACK}
        legends={[
            {
                dataFrom: 'keys',
                anchor: 'bottom-right',
                direction: 'column',
                justify: true,
                translateX: 120,
                translateY: 0,
                itemsSpacing: 2,
                itemWidth: 100,
                itemHeight: 20,
                itemDirection: 'left-to-right',
                itemOpacity: 0.85,
                symbolSize: 20,
                effects: [
                    {
                        on: 'hover',
                        style: {
                            itemOpacity: 1
                        }
                    }
                ]
            }
        ]}
        role="application"
        barAriaLabel={function(e){return e.id+": "+e.formattedValue+" in country: "+e.indexValue}}
    />
)

export default BarGroupedChart